import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { QuotationDocument } from './QuotationView';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function PublicQuotation() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [reasons, setReasons] = useState([]);
  useEffect(() => {
    axios.get(`${BACKEND}/api/public/quotation/${id}`).then(r => setD(r.data)).catch(() => setD({ error: true }));
    axios.get(`${BACKEND}/api/reason-codes`).catch(() => ({ data: [] })).then(r => setReasons(r?.data || []));
  }, [id]);
  if (!d) return <div className="p-6 text-sm text-[var(--muted)]">Loading…</div>;
  if (d.error) return <div className="p-8 text-center serif text-[24px]">Quotation not found</div>;
  const q = d.quotation;
  const advance = q.advance_amount || Math.round((q.total || 0) * (q.advance_pct || 30) / 100);
  return (
    <div className="min-h-screen py-6 px-4" style={{background:'var(--cream-alt)'}}>
      <div className="max-w-3xl mx-auto">
        <QuotationDocument q={q} settings={d.settings} reasons={reasons} advance={advance} editMode={false} onSave={() => {}}/>
      </div>
    </div>
  );
}
